var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 4H8L6.66667 2.66667H2.66667C1.93333 2.66667 1.34 3.26667 1.34 4L1.33333 12C1.33333 12.7333 1.93333 13.3333 2.66667 13.3333H13.8467C14.3 13.3333 14.6667 12.96 14.6667 12.5133V5.33333C14.6667 4.6 14.0667 4 13.3333 4ZM13.3333 12H2.66667V4H6.11333L7.44667 5.33333H13.3333V12ZM12 8H4V6.66667H12V8ZM9.33333 10.6667H4V9.33333H9.33333V10.6667Z",
    fill: "#264F3F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVat);
export default __webpack_public_path__ + "static/media/vat.b0641a07.svg";
export { ForwardRef as ReactComponent };